
        import { createElement as _createElement } from 'react';
import { Fragment as _Fragment } from 'react';
import _map from 'lodash-es/map';
export default function relatedItemsRT () {
    function repeatItems1(showExactFitBadge, items, itemsIndex) {
        return [items(function () {
                function mergeProps(inline, external) {
                    var res = Object.assign({}, inline, external);
                    if (inline.hasOwnProperty('style')) {
                        res.style = _.defaults(res.style, inline.style);
                    }
                    if (inline.hasOwnProperty('className') && external.hasOwnProperty('className')) {
                        res.className = external.className + ' ' + inline.className;
                    }
                    return res;
                }
                return _createElement('li', {}, _createElement('product-card', { 'class': 'card card--product h-full card--product-compare relative flex' }, _createElement('div', { 'className': 'card__media relative' }, _createElement('a', {
                    'href': this.url,
                    'aria-label': this.removeHTML(this.title),
                    'className': 'media block relative image-blend js-prod-link',
                    'tabIndex': '-1'
                }, _createElement('img', {
                    'className': 'img-fit card__main-image no-js-hidden',
                    'src': this.imageOrDefault(this.resizeImage(this.image)),
                    'data-media-id': this.id,
                    'loading': 'lazy',
                    'alt': this.removeHTML(this.title),
                    'onError': this.onImageError
                })), _createElement('div', { 'className': 'product-label-container' }, _createElement('div', { 'className': 'product-label-wrapper product-label-wrapper-left' }, showExactFitBadge && this.Fitment === 'Vehicle Specific' ? _createElement('span', {
                    'className': 'product-label product-label--exact-fit',
                    'key': '632'
                }, '\n            Exact Fit\n          ') : null, this.Fitment === 'Universal Fit' ? _createElement('span', {
                    'className': 'product-label product-label--universal',
                    'key': '819'
                }, '\n            Universal\n          ') : null), _createElement('div', { 'className': 'product-label-wrapper product-label-wrapper-right' }, this.on_sale ? _createElement('span', {
                    'className': 'product-label product-label--sale',
                    'key': '1061'
                }, 'Sale') : null, this.out_of_stock ? _createElement('span', {
                    'className': 'product-label product-label--sold-out',
                    'key': '1152'
                }, 'Sold out') : null))), _createElement('div', { 'className': 'card__info-container flex flex-col flex-auto relative' }, _createElement('div', { 'className': 'card__info w-full' }, _createElement('div', { 'className': 'card__info-inner inline-block w-full' }, _createElement('p', mergeProps({ 'className': 'card__vendor mb-1 text-sm text-theme-light' }, { dangerouslySetInnerHTML: { __html: this.vendor } })), _createElement('p', { 'className': 'card__title font-bold mb-1' }, _createElement('a', mergeProps({
                    'href': this.url,
                    'className': 'card-link text-current js-prod-link'
                }, { dangerouslySetInnerHTML: { __html: this.title } }))), _createElement('div', { 'className': 'price' }, _createElement('div', { 'className': 'price__default' }, this.price_varies ? _createElement('span', { 'key': '1869' }, 'From: ') : null, _createElement('strong', { 'className': 'price__current' }, this.formatPrice(this.price)), this.on_sale ? _createElement('s', {
                    'className': 'price__was',
                    'key': '2014'
                }, this.formatPrice(this.compare_at_price)) : null)))), _createElement('div', { 'className': 'card__quick-add mob:card__quick-add--below desktop:card__quick-add--below' }, _createElement('product-form', {}, _createElement('div', {
                    'className': 'alert mb-8 bg-error-bg text-error-text js-form-error text-start',
                    'role': 'alert',
                    'hidden': true
                }), _createElement('form', {
                    'method': 'post',
                    'action': '/cart/add',
                    'id': 'quick-add-' + this.id,
                    'acceptCharset': 'UTF-8',
                    'className': 'js-product-form',
                    'encType': 'multipart/form-data',
                    'noValidate': 'novalidate'
                }, _createElement('input', {
                    'type': 'hidden',
                    'name': 'form_type',
                    'value': 'product'
                }), _createElement('input', {
                    'type': 'hidden',
                    'name': 'utf8',
                    'value': '\u2713'
                }), _createElement('input', {
                    'type': 'hidden',
                    'name': 'product-id',
                    'value': this.id
                }), _createElement('input', {
                    'type': 'hidden',
                    'name': 'id',
                    'value': this.variant_ids[0]
                }), this.out_of_stock || !this.out_of_stock && this.variant_ids.length === 1 ? _createElement('button', {
                    'className': 'btn btn--primary w-full',
                    'data-add-to-cart-text': 'Add to cart',
                    'name': 'add',
                    'aria-haspopup': 'dialog',
                    'disabled': this.out_of_stock,
                    'key': '2861'
                }, _createElement('span', { 'className': 'quick-add-btn-text' }, !this.out_of_stock ? 'Add to cart' : 'Sold out')) : null)), !this.out_of_stock && this.variant_ids.length > 1 ? _createElement('button', {
                    'type': 'button',
                    'className': 'btn btn--primary w-full js-quick-add',
                    'aria-haspopup': 'dialog',
                    'data-product-url': this.url,
                    'data-product-default-variant': 'false',
                    'data-quick-add-listener-added': 'true',
                    'key': '3290'
                }, _createElement('span', { 'className': 'quick-add-btn-text block pointer-events-none' }, 'Choose options')) : null))));
            }, { count: undefined })];
    }
    function scopeShowExactFitBadge2() {
        var showExactFitBadge = window.Convermax.isVehicleSelected() && !window.Convermax.getSearchResponse?.()?.messages.includes('IncompatibleParts');
        return _createElement('div', { 'className': 'cm_related-products' }, _createElement('div', { 'className': 'cm_related-products-title-container' }, _createElement('h2', { 'className': 'h4 mt-10 cm_related-products-title' }, 'You might also like...')), _createElement.apply(this, [
            'div',
            { 'className': 'slider slider__grid grid grid-flow-col auto-cols-2 small-cards-mobile md:auto-cols-3 lg:auto-cols-4 xl:auto-cols-5 small-cards-desktop gap-x-theme gap-y-8 cm_related-products-list cmRepeater_items' },
            _map(this.items, repeatItems1.bind(this, showExactFitBadge))
        ]));
    }
    return scopeShowExactFitBadge2.apply(this, []);
}
        export const componentNames = []